const GroupFilesHubRecentFilesCardDefaultActionClickName =
    'GroupFilesHubRecentFilesCardDefaultActionClick';

export { GroupFilesHubRecentFilesCardDefaultActionClickName };
